module.exports = __webpack_public_path__ + "static/media/async_coin.f8ea549e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/async_coin.png
// module id = 219
// module chunks = 0